export function Expedientes() {
    return (
        <div className="content-section">
            <div className="main">
                <h1>Expedientes</h1>
            </div>
        </div>
    )
}
